import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgPhoneCall(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="10 10 38 39"
      fill="none"
      {...props}
    >
      <path
        stroke={props.primaryColor}
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={3}
        d="M31.496 44.907a26 26 0 0 1-1.684-.82 34.9 34.9 0 0 1-7.51-5.707 33 33 0 0 1-7.018-9.521 20.6 20.6 0 0 1-1.87-6.08 10.88 10.88 0 0 1 .678-6.34 11.6 11.6 0 0 1 1.894-2.34A3.3 3.3 0 0 1 18.328 13a3.67 3.67 0 0 1 2.34 1.356c1.263 1.404 2.619 2.668 3.952 4 .525.45.853 1.088.913 1.778a2.5 2.5 0 0 1-.632 1.568c-.444.562-.982 1.076-1.496 1.612a2.81 2.81 0 0 0-.844 2.34 6.75 6.75 0 0 0 1.615 2.669 64 64 0 0 0 2.784 3.53 25 25 0 0 0 6.337 5.24 2.34 2.34 0 0 0 2.342.282 7.4 7.4 0 0 0 2.082-1.73 3.08 3.08 0 0 1 2.012-1.101 2.77 2.77 0 0 1 1.848.844c.63.536 1.168 1.168 1.753 1.753s1.054 1.007 1.545 1.543q.884.78 1.66 1.661c.401.52.594 1.172.538 1.824a3.84 3.84 0 0 1-1.286 1.988 8.76 8.76 0 0 1-6.878 2.668 19.5 19.5 0 0 1-7.417-1.918Z"
      />
      <path
        stroke={props.secondaryColor}
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M40.543 26.688a7.33 7.33 0 0 0-2.118-5.16 7.2 7.2 0 0 0-5.112-2.139M45.5 26.177c0-1.534-.3-3.052-.88-4.469a11.7 11.7 0 0 0-2.509-3.788 11.6 11.6 0 0 0-3.753-2.532 11.5 11.5 0 0 0-4.428-.888"
      />
    </svg>
  );
}
export default SvgPhoneCall;
